// Description: Endpoint used to try to recover the password.
// Updated: 21/08/2025
// Author: Vitor de Jesus

import axios from 'axios';

export async function TryRecovery(data) {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_AWS_URL}/auth/recovery-password`,
            data,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response) {
            const status = error.response.status;
            if (status === 401) {
                return { 
                    status: 401,
                    message: 'Usuário ou senha inválidos.'
                };
            } else if (status === 429) {
                return {
                    status: 429,
                    message: 'Muitas solicitações. Tente novamente mais tarde.'
                };
            } else if (status === 404){
                return {
                    status: 404,
                    message: 'Esse email ou usuário é inválido.'
                };
            }
        }  
    }
}
